import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { INavigator } from './navigator';

@Component({
  selector: 'app-navigator',
  templateUrl: './navigator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigatorComponent {
  @Input()
  paths: INavigator[];
}
